"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  name: "Sarah Jenkins",
  location: "Local Business Owner",
  quote: "Rapid Tech Works transformed our chaotic network into a seamless operation. Their proactive monitoring gives me peace of mind I never knew I could have with IT.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646044/img/client_sarah_jenkins.png",
  initials: "SJ"
}, {
  id: 2,
  name: "Mark Thompson",
  location: "Thompson & Co. Law",
  quote: "The cabling job they did during our office remodel was immaculate. Professional, organized, and they actually care about the local businesses they serve here in Rapid City.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646044/img/client_mark_thompson.png",
  initials: "MT"
}, {
  id: 3,
  name: "Elena Rodriguez",
  location: "Valley Medical Clinic",
  quote: "Finally, an IT partner that speaks our language. They made our cloud migration simple and secure. It's refreshing to work with people who are so passionate about tech.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646044/img/client_elena_rodriguez.png",
  initials: "ER"
}];
export default function ClientTestimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223807" id="what-our-clients-say" className="relative py-24 bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none opacity-[0.04] text-secondary">
        <Quote className="w-64 h-64 md:w-96 md:h-96" />
      </div>

      <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            What Our Clients Say
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Real stories from local businesses we're proud to support in Rapid Valley.
          </p>
        </div>

        <div className="max-w-4xl mx-auto px-12 md:px-16">
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i}>
                  <div className="flex flex-col items-center text-center space-y-8 py-8">
                    {}
                    <div className="flex gap-1.5 justify-center">
                      {[...Array(5)].map((_, starIndex) => <Star key={starIndex} data-index={starIndex} className="w-6 h-6 md:w-7 md:h-7 fill-primary text-primary" />)}
                    </div>

                    {}
                    <blockquote className="text-xl md:text-3xl italic font-serif text-foreground/90 leading-relaxed max-w-3xl">
                      "{testimonial.quote}"
                    </blockquote>

                    {}
                    <div className="flex flex-col items-center space-y-3">
                      <SafeHydrate><Avatar className="w-20 h-20 border-2 border-secondary/20 shadow-md">
                        <AvatarImage src={testimonial.avatar} alt={testimonial.name} />
                        <AvatarFallback className="bg-secondary/10 text-secondary font-semibold text-xl font-default">
                          {testimonial.initials}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div>
                        <div className="font-bold text-foreground font-default text-xl">
                          {testimonial.name}
                        </div>
                        <div className="text-sm font-medium text-secondary uppercase tracking-wider font-default">
                          {testimonial.location}
                        </div>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex -left-4 bg-card border-border text-secondary hover:bg-secondary hover:text-secondary-foreground hover:shadow-lg transition-all duration-300" />
            <CarouselNext className="hidden md:flex -right-4 bg-card border-border text-secondary hover:bg-secondary hover:text-secondary-foreground hover:shadow-lg transition-all duration-300" />
          </Carousel>
        </div>
      </div>
    </section>;
}